import { render, staticRenderFns } from "./ChallengeSettingsModal.vue?vue&type=template&id=79900ea1&scoped=true&"
import script from "./ChallengeSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ChallengeSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeSettingsModal.vue?vue&type=style&index=0&id=79900ea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79900ea1",
  null
  
)

export default component.exports